import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSpinnerComponent } from './custom-spinner/custom-spinner.component';
import { CommonFacilityGridComponent } from './common-facility-grid/common-facility-grid.component';
import { TableModule } from 'primeng/table';
import {ImageModule} from 'primeng/image';
import { ButtonModule } from 'primeng/button';


@NgModule({
  declarations: [
    CustomSpinnerComponent,
    CommonFacilityGridComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    ImageModule,
    ButtonModule
  ],
  exports:[
    CustomSpinnerComponent,
    CommonFacilityGridComponent
  ]
})
export class SharedModule { }
